import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from '../Shared/Services/shared.service';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class AgentsService {
  readonly APIurl = environment.apiUrl;
  constructor(private http: HttpClient, private shared: SharedService) { }

  GetAllAgents() {
    return this.http.get(`${this.APIurl}/Agent/GetAllAgents`, this.shared.options);
  }

  GetAgentData(agentId: any) {
    return this.http.get(`${this.APIurl}/Agent/GetAgentData?id=${agentId}`, this.shared.options);
  }

  DeleteAgent(agentId: any) {
    return this.http.get(`${this.APIurl}/Agent/DeleteAgent?Ids=${agentId}`, this.shared.options);
  }

  EditAgent(data: any) {
    return this.http.post(`${this.APIurl}/Agent/EditAgent`, data, this.shared.options);
  }
}
